import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { AuthModal } from "./components/AuthModal";
import { Toaster } from "./components/ui/sonner";
import { DiscordButton } from "./components/DiscordButton";
import Home from "./pages/Home";
import SubmitReport from "./pages/SubmitReport";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import Analytics from "./pages/Analytics";
import PlayerProfile from "./pages/PlayerProfile";
import HunterProfile from "./pages/HunterProfile";
import Builder from "./pages/Builder";
import MyBuilds from "./pages/MyBuilds";
import Compare from "./pages/Compare";
import MyReports from "./pages/MyReports";
import Supporter from "./pages/Supporter";
import Track from "./pages/Track";
import Search from "./pages/Search";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import ApplyModder from "./pages/ApplyModder";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function Footer() {
  return (
    <footer className="mt-16 border-t border-[#1E293F] bg-[#0F1424]">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        <div className="flex flex-col items-center justify-between gap-3 text-sm text-[#64748B] sm:flex-row">
          <img src="/logo.webp" alt="2K Case Files" className="h-10 w-auto object-contain" />
          <div className="flex items-center gap-5">
            <DiscordButton variant="footer" />
            <a href="/about" className="hover:text-white">About</a>
            <a href="/faq" className="hover:text-white">FAQ</a>
            <a href="/stats" className="hover:text-white">Stats</a>
            <a href="/track" className="hover:text-white">Track a Report</a>
            <a href="/supporter" className="hover:text-white">Support Us</a>
          </div>
          <span>Community-run NBA 2K anti-cheat. Not affiliated with 2K Games.</span>
        </div>
      </div>
    </footer>
  );
}

function Shell() {
  const location = useLocation();
  const { authOpen, closeAuth } = useAuth();

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen bg-[#090C15]">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/submit" element={<SubmitReport />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/stats" element={<Analytics />} />
          <Route path="/players/:platform/:gamertag" element={<PlayerProfile />} />
          <Route path="/hunters/:userId" element={<HunterProfile />} />
          {/* BUILD LAB — hidden from live site (unpublished). Re-enable these 4 routes + the Navbar links to launch it. */}
          {/* <Route path="/builder" element={<Builder />} /> */}
          {/* <Route path="/build/:id" element={<Builder />} /> */}
          {/* <Route path="/builds" element={<MyBuilds />} /> */}
          {/* <Route path="/compare" element={<Compare />} /> */}
          <Route path="/my" element={<MyReports />} />
          <Route path="/supporter" element={<Supporter />} />
          <Route path="/track" element={<Track />} />
          <Route path="/track/:id" element={<Track />} />
          <Route path="/search" element={<Search />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />          <Route path="/apply" element={<ApplyModder />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <AuthModal open={authOpen} onClose={closeAuth} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
        <Toaster position="top-center" theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
